import { styled } from '@innowise-group/mui-kit';

export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  grid-column: span 2;

  & .MuiFormControlLabel-label {
    white-space: break-spaces;
  }
`;
